//#region import libraries
import React from 'react';

// atoms
import { Accordion } from '_atoms';
import AnswerOptions from './answer-options';

// bootstrap
import { Form } from 'react-bootstrap'

// styling
import { Colors } from '_styles';

// question types (single source of truth)
import { typeLabel, typeNeedsOptions } from './survey-question-types';

//#endregion

const MatrixScale5View = ({ question, questionIndex }) => {
    const scaleIndices = [0, 1, 2, 3, 4];

    // Get all available languages from the first item (or from question text as fallback)
    const availableLanguages = question.items?.[0]?.text
        ? Object.keys(question.items[0].text)
        : Object.keys(question.text || {});

    // Check if custom scale labels exist
    const hasScaleLabels = question.scaleLabels && Object.keys(question.scaleLabels).length > 0;

    // Build combined scale labels (e.g., "Excelente / Excellent")
    const getCombinedLabel = (index) => {
        if (!hasScaleLabels) return index + 1; // fallback to number
        const labelParts = availableLanguages
            .map(lang => question.scaleLabels?.[lang]?.[index])
            .filter(label => label && label.trim());
        return labelParts.length > 0 ? labelParts.join(' / ') : index + 1;
    };

    // Build combined item text (e.g., "Cortesía y Amabilidad del Personal / Courtesy and Friendliness of the Staff")
    const getCombinedItemText = (item) => {
        const textParts = availableLanguages
            .map(lang => item.text?.[lang])
            .filter(text => text && text.trim());
        return textParts.length > 0 ? textParts.join(' / ') : '—';
    };

    return (
        <div style={{ marginTop: 12 }}>
            {/* Header row with scale labels */}
            <div style={{ display: 'flex', alignItems: 'flex-end', padding: '10px 6px', borderBottom: '2px solid #e0e0e0' }}>
                <div style={{ flex: 2 }}></div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                    {scaleIndices.map((idx) => (
                        <div key={idx} style={{ textAlign: 'center', flex: 1, fontSize: 12, color: '#555' }}>
                            {getCombinedLabel(idx)}
                        </div>
                    ))}
                </div>
            </div>

            {/* Matrix rows */}
            <div style={{ marginBottom: 8 }}>
                {question.items?.map((item, rowIndex) => (
                    <div key={rowIndex} style={{ padding: '10px 6px', borderBottom: '1px solid #f0f0f0' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flex: 2 }}>
                                <div style={{ fontWeight: 500 }}>
                                    {getCombinedItemText(item)}
                                </div>
                            </div>

                            <div style={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                {scaleIndices.map((idx) => (
                                    <div key={idx} style={{ textAlign: 'center', flex: 1 }}>
                                        <input type="radio" disabled name={`matrix-${questionIndex}-${rowIndex}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const QuestionComponent = (props) => {

    return (
        <Accordion
            header={"Question " + props.questionIndex}
            active={props.active}
            onStateChange={(state) => {
                console.log("state changed");
            }}
        >
            <div style={{ flex: 1, marginBottom: "4px" }}>
                {/* Question Text for Each Language */}
                {Object.entries(props.question.text).map(([lang, text]) => (
                    <div key={lang} style={{ flex: 1, marginTop: "4px", direction: lang === "ar" ? "rtl" : "ltr" }}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>
                            Question Text ({lang.toUpperCase()})
                        </Form.Label>
                        <Form.Control
                            disabled={true}
                            type="text-area"
                            value={text}
                        />
                    </div>
                ))}

                {/* Answer Type */}
                <div style={{ flex: 1, marginTop: "4px" }}>
                    <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>
                        Answer Type
                    </Form.Label>
                    <Form.Control
                        disabled={true}
                        type="text"
                        value={typeLabel(props.question.type)}
                    />
                </div>

                {/* Stars Count for Rating Type */}
                {props.question.type === 'rating' && (
                    <div style={{ flex: 1, marginTop: "4px" }}>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>
                            Number of Stars
                        </Form.Label>
                        <Form.Control
                            disabled={true}
                            type="text"
                            value={props.question.starsCount || 5}
                        />
                    </div>
                )}

                {/* Answer Options for Each Language */}
                {typeNeedsOptions(props.question.type) && (
                    <div style={{ flex: 1, marginTop: "4px" }}>
                        {Object.entries(props.question.options || {}).map(([lang, options]) => (
                            <AnswerOptions key={lang} options={options} language={lang} readOnly={true} />
                        ))}
                    </div>
                )}

                {props.question.type === 'matrix-scale5' && (
                    <MatrixScale5View question={props.question} questionIndex={props.questionIndex} />
                )}
            </div>
        </Accordion>
    );
};

export default QuestionComponent;